// extracted by mini-css-extract-plugin
module.exports = {"main_container":"AssetTypeDetailPage_main_container__UU-lR","red_text":"AssetTypeDetailPage_red_text__wo5Y5","delete_buttons":"AssetTypeDetailPage_delete_buttons__3yL5s"};